export const SUPERLATIVE_COPY = {
  "Trivia Wiz": "Most right answers — pure skill.",
  "Come From Behind": "Hunted down the lead. Caught it.",
  "Comeback Kid": "Down bad. Back up. Made it.",
  "Fastest Trigger": "Buzzed in faster than anyone.",
  "Daily Double Daredevil": "Bet huge. Won huge.",
  "In Control": "First to nail it — over and over.",
  "Hottest Streak": "On a tear. Couldn't be stopped.",
  "Buzzer Beater": "Cut it close. Got it anyway.",
  "Big Guesser": "Swung at every pitch.",
  "Over Confident": "Bold answers. Wrong ones.",
  "Most Risk Averse": "Picked spots. Stayed clean.",
  "Late Bloomer": "Last to get on the board.",
  "Under the Radar": "Never led, never last — just quietly stacking points.",
};
